import React from 'react';
import { searchPageStyles } from './SearchPage.styles';
import { SEARCH_TYPE_LABELS } from './SearchPage.constants';

const SearchTypeTabs = ({ 
  currentSearchType, 
  setCurrentSearchType, 
  query 
}) => {
  const handleTabClick = (type) => {
    setCurrentSearchType(type);
    const newUrl = `/s?q=${encodeURIComponent(query)}&type=${type}`;
    // Reload page with new search type and same query
    window.location.href = newUrl;
  };

  return (
    <div style={searchPageStyles.searchTypeTabsContainer}>
      <div 
        className="search-type-tabs"
        style={searchPageStyles.searchTypeTabs}
      >
        {Object.entries(SEARCH_TYPE_LABELS).map(([type, label]) => (
          <button
            key={type}
            onClick={() => handleTabClick(type)}
            style={{
              ...searchPageStyles.searchTypeTab,
              background: currentSearchType === type ? 'var(--color-primary)' : 'transparent',
              color: currentSearchType === type ? 'var(--color-bg-card)' : 'var(--color-text)',
              borderBottom: currentSearchType === type ? '2px solid var(--color-primary)' : '2px solid transparent',
              fontWeight: currentSearchType === type ? '600' : '500',
            }}
            onMouseOver={(e) => {
              if (currentSearchType !== type) {
                e.target.style.background = 'var(--color-bg)';
              }
            }}
            onMouseOut={(e) => {
              if (currentSearchType !== type) {
                e.target.style.background = 'transparent';
              }
            }}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SearchTypeTabs; 